<template>
  <v-card v-if="formData">
    <v-card-title>
      Edit<b>&ensp;{{routeLabel}}&ensp;</b>metadata
    </v-card-title>
    <v-card-text>
      <v-layout wrap row>
        <v-flex>
          <content-field
            v-model="formData.canonicalLink"
            :error="$v.formData.canonicalLink"
            label="Canonial link"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex>
          <content-field
            v-model="formData.metaTitle"
            :error="$v.formData.metaTitle"
            label="Meta title"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex>
          <content-editor
            v-model="formData.metaDescription"
            :error="$v.formData.metaDescription"
            label="Meta description"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn class="green white--text" @click="emitChange">Change</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { path, assocPath } from 'ramda'
import { required, url } from 'vuelidate/lib/validators'
import ContentField from '@/components/shared/ContentField'
import ContentEditor from '@/components/shared/ContentEditor'

export default {
  name: 'EditRouteMetadataForm',
  components: {
    ContentField,
    ContentEditor
  },
  props: {
    routeData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  computed: {
    routeLabel () {
      return path(['metadata', 'label'], this.routeData)
    }
  },
  validations: {
    formData: {
      canonicalLink: { required, url },
      metaTitle: { required },
      metaDescription: { required }
    }
  },
  watch: {
    routeData () {
      this.formData = path(['metadata', 'content'], this.routeData)
    }
  },
  methods: {
    emitChange () {
      this.$v.$touch()
      if (this.$v.formData.$invalid) return
      this.$v.formData.$reset()
      const emitPayload = assocPath(['metadata', 'content'], this.formData, this.routeData)
      this.$emit('metadataChanged', emitPayload)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/SEO/editMetadataForm.vue